import { Spinner } from "react-bootstrap";
import quotes from "../../assets/misc/quotes.json";
import {useMemo} from "preact/hooks";



export default function PageLoader({ message, size = 'lg', spinner = true, width = 80, height = 80 }) {

    const pickRandomQuote = () => {
        return quotes[Math.floor(Math.random() * quotes.length)];
    }

    const pickedQuote = useMemo(() => pickRandomQuote(), []);

    return <>
        <div class="d-flex flex-column gap-4 justify-content-center align-items-center pt-4 animate__animated animate animate__fadeIn">
            {spinner ? <Spinner animation="grow" variant="primary-brand-color" size={size} /> : <>
                <svg style="margin: auto; display: block; shape-rendering: auto;" width={width} height={height} viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <g transform="translate(50,50)">
                        <g transform="scale(0.7)">
                            <circle cx="0" cy="0" r="50" fill="#e90c59"></circle>
                            <circle cx="0" cy="-28" r="15" fill="#ffffff">
                                <animateTransform attributeName="transform" type="rotate" dur="1.075268817204301s" repeatCount="indefinite" keyTimes="0;1" values="0 0 0;360 0 0"></animateTransform>
                            </circle>
                        </g>
                    </g></svg> </>}

            {message ? <span>{message}</span> : 'Chargement en cours...'}

            <figure className="text-center w-25">
                <blockquote className="blockquote">
                    <p>
                        {pickedQuote.quote}
                    </p>
                </blockquote>
                <figcaption className="blockquote-footer">
                    {pickedQuote.author}
                </figcaption>
            </figure>
        </div>
    </>

}